<app-paged-table mode="base-2">
  <ng-container thead>
    <tr class="text-right">
      <th>
        {{ 'Transaction type' | trans:'customers/transactions-positons/transactionType.Label' }}
      </th>
      <th>
        {{ 'Amount' | trans:'customers/transactions-positons/amount.Label' }}
      </th>
      <th>
        {{ 'Processing time' | trans:'customers/transactions-positons/processingTime.Label' }}
      </th>
      <th>
        {{ 'Operator' | trans:'customers/transactions-positons/operator.Label' }}
      </th>
      <th>
        {{ 'Terminal' | trans:'customers/transactions-positons/terminal.Label' }}
      </th>
      <th>
        {{ 'Ticket number' | trans:'customers/transactions-positons/ticketNumber.Label' }}
      </th>
      <th>
        {{ 'Voucher number' | trans:'customers/transactions-positons/voucherNumber.Label' }}
      </th>
    </tr>
  </ng-container>

  <ng-container tbody>
    @for (t of data; track t.transactionId) {
      <tr class="text-right">
        <td>
          <p class="t4 fw-medium c-t-blue-700 text-uppercase">
            {{ t.transactionType | trans:'customers/transactions-positons/transactionType/type.' + t.transactionType }}
          </p>
        </td>
        <td>
          {{ t.transactionAmount | numberToCurrency }} {{ languageConfig.currency.short }}
        </td>
        <td>
          <p class="p1">
            {{ t.openingDate | localeDateFormat }}<br>
            {{ t.openingDate | timeFormat }}
          </p>
        </td>
        <td>
          {{ t.consumer }}
        </td>
        <td>
          {{ t.terminalName }}
        </td>
        <td>
          {{ t.ticketNr | empty }}
        </td>
        <td>
          {{ t.voucherNr | empty }}
        </td>
      </tr>
    }
  </ng-container>
</app-paged-table>
